import './App.css';
import StartPage from './StartPage';

function App() {
  return <div style={{ background: '#060410' }}>
    <StartPage />
  </div>;
};

export default App;
